export default {
  title: 'Thanks {{firstName}} {{lastName}}',
  subTitle: 'Your booking is confirmed.',
  orderedBy: 'Ordered By: {{type}}',
  seat: 'Seat {{seat}}',
  paymentTypes: {
    creditCard: 'Credit Card',
    correspondance: 'Correspondance',
    opusCard: 'OPUS Card',
    cashOnBoard: 'Cash on Board',
    free: 'Free',
    opusCardMensuel: 'Carte OPUS - Mensuel',
    opusCardPassage: 'Carte OPUS - Passage',
    cpoPassage: 'Carte a puce occasionnelle (CPO) - Passage',
  },
};
